var render = function render(){var _vm=this,_c=_vm._self._c;return _c('share-popover',{attrs:{"category":_vm.category,"context":_vm.context,"flashcard":_vm.flashcard,"popover-title":_vm.title,"popover-description":_vm.text,"share-messsage":_vm.message,"share-text":"SHARE","url":_vm.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }